const GOLD_COLOR = {
  R: 247,
  G: 183,
  B: 51,
};

const GRAY_COLOR = {
  R: 186,
  G: 194,
  B: 204,
};

const STEP_POINT_RADIUS = 16;

/**
 * During animation each colours are changing from gold to grey according to your position.
 * Maximum difference between gold and grey is MAX_DELTA_BETWEEN_GOLD_AND_GRAY pixels.
 *
 */
const MAX_DELTA_BETWEEN_GOLD_AND_GRAY = 75;

const LANDING_STEPS_TREE = [
  {
    horizontal: {
      index: 0,
      horizontalLinePosition: '',
    },
    vertical: {
      index: 0,
      left: {
        text: '',
        isTitle: false,
      },
      right: {
        text: 'STEP 1: 10 SECONDS',
        isTitle: true,
      },
      needVerticalLine: true,
    },
  },
  {
    horizontal: {
      index: 1,
      horizontalLinePosition: 'right',
    },
    vertical: {
      index: 1,
      left: {
        text: 'STEP 2: 30 SECONDS',
        isTitle: true,
      },
      right: {
        text: 'Add an account of your choice to the cart',
        isTitle: false,
      },
      needVerticalLine: true,
    },
  },
  {
    horizontal: {
      index: 2,
      horizontalLinePosition: 'left',
    },
    vertical: {
      index: 2,
      left: {
        text:
          'Checkout & pay one of the 200 different payment method available',
        isTitle: false,
      },
      right: {
        text: 'STEP 3: 20 SECONDS',
        isTitle: true,
      },
      needVerticalLine: true,
    },
  },
  {
    horizontal: {
      index: 3,
      horizontalLinePosition: 'right',
    },
    vertical: {
      index: 3,
      left: {
        text: 'STEP 4: 1 MINUTE',
        isTitle: true,
      },
      right: {
        text:
          'The account is delivered almost instantly to the email you provided us prior to purchase',
        isTitle: false,
      },
      needVerticalLine: true,
    },
  },
  {
    horizontal: {
      index: 4,
      horizontalLinePosition: 'left',
    },
    vertical: {
      index: 4,
      left: {
        text: 'Your account is ready for you to queue up',
        isTitle: false,
      },
      right: {
        text: '',
        isTitle: false,
      },
      needVerticalLine: false,
    },
  },
];

const LANDING_STEPS_COUNT = LANDING_STEPS_TREE.length;

/**
 *  To make it more responsive for the user, the animation starts a little bit later,
 *  so the user can notice the difference which is more comfortable for the eye.
 *  VIRTUAL_DIFFERENCE_FOR_STEP_POINTS defines how late the animation should start.
 */
const VIRTUAL_DIFFERENCE_FOR_STEP_POINTS = 250;

export const LandingPageConstants = {
  data() {
    return {
      GOLD_COLOR: GOLD_COLOR,
      GRAY_COLOR: GRAY_COLOR,
      STEP_POINT_RADIUS: STEP_POINT_RADIUS,
      MAX_DELTA_BETWEEN_GOLD_AND_GRAY: MAX_DELTA_BETWEEN_GOLD_AND_GRAY,
      LANDING_STEPS_TREE: LANDING_STEPS_TREE,
      VIRTUAL_DIFFERENCE_FOR_STEP_POINTS: VIRTUAL_DIFFERENCE_FOR_STEP_POINTS,
      LANDING_STEPS_COUNT: LANDING_STEPS_COUNT,
    };
  },

  methods: {
    getRGB(color) {
      return 'rgb(' + color.R + ', ' + color.G + ', ' + color.B + ')';
    },

    /**
     * We define the point color based on the distance between your and points position.
     */
    colorLerp(deltaY) {
      if (deltaY > MAX_DELTA_BETWEEN_GOLD_AND_GRAY) {
        return GRAY_COLOR;
      } else if (deltaY <= 0) {
        return GOLD_COLOR;
      }

      let R =
        GOLD_COLOR.R +
        ((GRAY_COLOR.R - GOLD_COLOR.R) * deltaY) /
          MAX_DELTA_BETWEEN_GOLD_AND_GRAY;
      let G =
        GOLD_COLOR.G +
        ((GRAY_COLOR.G - GOLD_COLOR.G) * deltaY) /
          MAX_DELTA_BETWEEN_GOLD_AND_GRAY;
      let B =
        GOLD_COLOR.B +
        ((GRAY_COLOR.B - GOLD_COLOR.B) * deltaY) /
          MAX_DELTA_BETWEEN_GOLD_AND_GRAY;

      return { R, G, B };
    },
  },
};
